import * as React from "react";
import { forwardRef } from "react";
const SvgCloseDark = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { preserveAspectRatio: "none", overflow: "visible", style: {
  display: "block"
}, width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "close" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z", fill: "#1B1B1E" })));
const ForwardRef = forwardRef(SvgCloseDark);
export { ForwardRef as ReactComponent };
